export const API_URL = 'http://localhost/my-apps/bueno/bueno-api/api/';
//export const TRACKING_ID = "";

// export const API_URL = 'https://api.bueno.com/api/';
export const TRACKING_ID = 'UA-211303839-1';
